import { render, staticRenderFns } from "./examSystem.vue?vue&type=template&id=44642432&"
import script from "./examSystem.vue?vue&type=script&lang=js&"
export * from "./examSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports